import { IInitialViewpoint, ITopicPoint } from 'Data/interfaces/Activities/IViewpointData';
import { IUrnFilenameMap, ViewpointCaptureService } from 'Services/ViewpointCaptureService';
import { ViewpointRestoreService } from 'Services/ViewpointRestoreService';
import { IViewpointEngine } from './IViewpointEngine';

/**
 * O motor da Autodesk atrás do mesmo contrato do ifc-lite. Não muda
 * comportamento — só embrulha os dois serviços que já existiam, para quem
 * consome deixar de depender de `Autodesk.Viewing.GuiViewer3D`.
 */
export class AutodeskViewpointEngine implements IViewpointEngine {
  constructor(
    private readonly viewer: Autodesk.Viewing.GuiViewer3D | null,
    private readonly getUrnFilenameMap: () => IUrnFilenameMap,
  ) {}

  isReady(): boolean {
    return !!this.viewer;
  }

  capture(): Promise<IInitialViewpoint> {
    if (!this.viewer) { return Promise.reject(new Error('Viewer não está montado')); }

    return ViewpointCaptureService.captureCurrentViewpoint(this.viewer, this.getUrnFilenameMap());
  }

  apply(viewpoint: IInitialViewpoint, topicPoints?: ITopicPoint[]): void {
    if (!this.viewer) { return; }

    ViewpointRestoreService.applyViewpoint(this.viewer, viewpoint, topicPoints);
  }
}
